import React from 'react';
import { Icon } from '@iconify/react';
import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';

function FeaturesPage() {
  return (
    <div style={{
      minHeight: '100vh',
      background: '#000000',
      color: '#ffffff',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <Navigation />

      {/* Features Section */}
      <section style={{
        position: 'relative',
        marginTop: 'clamp(2rem, 4vw, 3rem)',
        padding: 'clamp(2rem, 5vw, 3rem) clamp(1.5rem, 5vw, 3rem)',
        maxWidth: '1200px',
        margin: 'clamp(2rem, 4vw, 3rem) auto'
      }}>
        {/* Section Title */}
        <h2 style={{
          fontSize: 'var(--font-3xl)',
          fontWeight: '700',
          color: '#ffffff',
          textAlign: 'center',
          marginBottom: 'clamp(3rem, 5vw, 4rem)',
          lineHeight: '1.2'
        }}>
          我們的特色
        </h2>

        {/* Cards Container */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 'clamp(2rem, 4vw, 3rem)',
          width: '100%'
        }}>

            {/* Card 2: 差異化價值 */}
            <div
              style={{
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
                gap: 'clamp(1.5rem, 3vw, 2rem)',
                minHeight: 'clamp(400px, 50vh, 500px)',
                width: '100%',
                overflow: 'hidden',
                borderRadius: 'clamp(16px, 3vw, 24px)',
                background: '#1a1a1a',
                backdropFilter: 'blur(10px)',
                padding: 'clamp(2rem, 4vw, 3rem)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.boxShadow = '0 20px 40px rgba(135, 206, 235, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <h3 style={{
                fontSize: 'var(--font-xl)',
                fontWeight: '600',
                color: '#ffffff',
                marginBottom: '0.5rem',
                textAlign: 'center',
                width: '100%'
              }}>
                差異化價值
              </h3>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 'clamp(1.5rem, 3vw, 2rem)',
                width: '100%'
              }}>
                {[
                  {
                    number: '01',
                    title: '不只是排程工具',
                    description: '而是 AI 驅動的社群經營公司'
                  },
                  {
                    number: '02',
                    title: '全流程自動化',
                    description: '從內容生成 → 圖卡製作 → 自動發佈 → 成效優化'
                  },
                  {
                    number: '03',
                    title: '專業級行銷服務',
                    description: '讓中小企業、個人品牌用最低成本享受專業級服務'
                  }
                ].map((value, index) => (
                  <div
                    key={index}
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '1rem',
                      padding: '1rem',
                      background: 'rgba(135, 206, 235, 0.05)',
                      borderRadius: '12px',
                      border: '1px solid rgba(135, 206, 235, 0.2)'
                    }}
                  >
                    <div style={{
                      fontSize: 'var(--font-3xl)',
                      fontWeight: '700',
                      color: '#87CEEB',
                      opacity: '0.5',
                      flexShrink: 0
                    }}>
                      {value.number}
                    </div>
                    <div style={{ flex: 1 }}>
                      <h4 style={{
                        fontSize: 'var(--font-xs)',
                        fontWeight: '600',
                        color: '#ffffff',
                        marginBottom: '0.5rem'
                      }}>
                        {value.title}
                      </h4>
                      <p style={{
                        fontSize: 'var(--font-xxs)',
                        color: 'rgba(255, 255, 255, 0.7)',
                        lineHeight: '1.5',
                        margin: 0
                      }}>
                        {value.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Card 3: 3 步驟 */}
            <div
              style={{
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
                gap: 'clamp(1.5rem, 3vw, 2rem)',
                minHeight: 'clamp(400px, 50vh, 500px)',
                width: '100%',
                overflow: 'hidden',
                borderRadius: 'clamp(16px, 3vw, 24px)',
                background: '#1a1a1a',
                backdropFilter: 'blur(10px)',
                padding: 'clamp(2rem, 4vw, 3rem)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.boxShadow = '0 20px 40px rgba(135, 206, 235, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <h3 style={{
                fontSize: 'var(--font-xl)',
                fontWeight: '600',
                color: '#ffffff',
                marginBottom: '0.5rem',
                textAlign: 'center',
                width: '100%'
              }}>
                3 步驟，24 小時內啟動您的 AI 內容系統
              </h3>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 'clamp(1.5rem, 3vw, 2rem)',
                width: '100%'
              }}>
                {[
                  {
                    number: '1',
                    title: "快速輸入設定",
                    desc: "僅需提供關鍵字、品牌語氣、目標受眾與發佈規則等簡易資訊"
                  },
                  {
                    number: '2',
                    title: "智能 AI 生成",
                    desc: "自動抓取熱門內容、結構化改寫，並生成客製文案與圖卡"
                  },
                  {
                    number: '3',
                    title: "自動發佈與優化",
                    desc: "Threads 自動排程發佈，實時回收數據，持續優化內容策略"
                  }
                ].map((step, index) => (
                  <div
                    key={index}
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '1rem',
                      padding: '1rem',
                      background: 'rgba(135, 206, 235, 0.05)',
                      borderRadius: '12px',
                      border: '1px solid rgba(135, 206, 235, 0.2)'
                    }}
                  >
                    <div style={{
                      width: '40px',
                      height: '40px',
                      borderRadius: '50%',
                      background: '#87CEEB',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 'var(--font-base)',
                      fontWeight: '700',
                      color: 'white',
                      flexShrink: 0
                    }}>
                      {step.number}
                    </div>
                    <div style={{ flex: 1 }}>
                      <h4 style={{
                        fontSize: 'var(--font-xs)',
                        fontWeight: '600',
                        color: '#ffffff',
                        marginBottom: '0.5rem'
                      }}>
                        {step.title}
                      </h4>
                      <p style={{
                        fontSize: 'var(--font-xxs)',
                        color: 'rgba(255, 255, 255, 0.7)',
                        lineHeight: '1.5',
                        margin: 0
                      }}>
                        {step.desc}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Card 4: 轉型成效 - 4 Vertical Cards Grid */}
            <div
              style={{
                width: '100%'
              }}
            >
              <h3 style={{
                fontSize: 'var(--font-xl)',
                fontWeight: '600',
                color: '#ffffff',
                marginBottom: '2rem',
                textAlign: 'center'
              }}>
                您將獲得的轉型成效
              </h3>

              {/* Grid Container - 4 Cards */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: 'clamp(1rem, 2vw, 1.5rem)',
                width: '100%'
              }}>
                {[
                  {
                    title: "大幅節省時間與成本",
                    badge: "成本降低",
                    metric: "90–95%",
                    arrow: "↓",
                    mainText: "內容產出速度提升",
                    highlight: "10 倍",
                    subText: "節省 90–95% 人力成本",
                    detailText: "讓您將資源投入到核心業務，專注於策略性增長而非重複性工作。"
                  },
                  {
                    title: "確保品牌一致性與規模化",
                    badge: "一致性",
                    metric: "100%",
                    arrow: "",
                    mainText: "每件內容維持統一",
                    highlight: "語氣與設計",
                    subText: "可輕鬆擴張到多平台",
                    detailText: "確保所有輸出皆符合品牌指南，實現 100% 一致性，為規模化奠定基礎。"
                  },
                  {
                    title: "加速測試與市場驗證",
                    badge: "測試速度",
                    metric: "×10",
                    arrow: "↗",
                    mainText: "每日生成",
                    highlight: "多變體測試稿",
                    subText: "轉換率提升 3x",
                    detailText: "快速迭代市場驗證流程，確保在最短時間內找到最佳溝通策略。"
                  },
                  {
                    title: "突破冷啟動障礙",
                    badge: "啟動加速",
                    metric: "×5",
                    arrow: "↗",
                    mainText: "快速建立",
                    highlight: "曝光循環",
                    subText: "達成病毒式成長",
                    detailText: "有效解決新平台初期的內容和流量困境，實現快速、指數級的增長。"
                  }
                ].map((benefit, index) => (
                  <div
                    key={index}
                    style={{
                      background: 'linear-gradient(135deg, #87CEEB 0%, #000000 100%)',
                      borderRadius: 'clamp(12px, 2vw, 16px)',
                      padding: 'clamp(1.5rem, 3vw, 2rem)',
                      display: 'flex',
                      flexDirection: 'column',
                      boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                      minHeight: '400px'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-8px)';
                      e.currentTarget.style.boxShadow = '0 12px 32px rgba(135, 206, 235, 0.4)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 8px 24px rgba(0, 0, 0, 0.3)';
                    }}
                  >
                    {/* Badge */}
                    <div style={{
                      background: 'rgba(255, 255, 255, 0.2)',
                      color: 'white',
                      padding: '0.25rem 0.75rem',
                      borderRadius: '9999px',
                      fontSize: 'var(--font-xxxs)',
                      fontWeight: '600',
                      alignSelf: 'flex-start',
                      marginBottom: '1rem'
                    }}>
                      {benefit.badge}
                    </div>

                    {/* Metric Number */}
                    <div style={{
                      fontSize: 'var(--font-5xl)',
                      lineHeight: '1',
                      fontWeight: '300',
                      color: '#93c5fd',
                      marginBottom: '1rem'
                    }}>
                      {benefit.metric}
                      {benefit.arrow && (
                        <span style={{
                          fontSize: 'var(--font-xl)',
                          marginLeft: '0.5rem',
                          display: 'inline-block',
                          verticalAlign: 'top'
                        }}>
                          {benefit.arrow}
                        </span>
                      )}
                    </div>

                    {/* Title */}
                    <h4 style={{
                      fontSize: 'var(--font-sm)',
                      fontWeight: '700',
                      color: '#ffffff',
                      lineHeight: '1.3',
                      marginBottom: '1rem',
                      margin: 0,
                      marginBottom: '1rem'
                    }}>
                      {benefit.title}
                    </h4>

                    {/* Main Text with Highlight */}
                    <div style={{
                      fontSize: 'var(--font-xs)',
                      lineHeight: '1.5',
                      color: '#ffffff',
                      marginBottom: '0.5rem',
                      fontWeight: '500'
                    }}>
                      {benefit.mainText}{' '}
                      <span style={{ fontWeight: '700', color: '#93c5fd' }}>
                        {benefit.highlight}
                      </span>
                    </div>

                    {/* Sub Text */}
                    <div style={{
                      fontSize: 'var(--font-xs)',
                      lineHeight: '1.5',
                      color: '#ffffff',
                      marginBottom: '1rem',
                      fontWeight: '500'
                    }}>
                      {benefit.subText}
                    </div>

                    {/* Detail Text */}
                    <p style={{
                      fontSize: 'var(--font-xxs)',
                      color: 'rgba(255, 255, 255, 0.7)',
                      lineHeight: '1.6',
                      marginTop: 'auto',
                      margin: 0
                    }}>
                      {benefit.detailText}
                    </p>
                  </div>
                ))}
              </div>
            </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default FeaturesPage;
